import React from 'react';
import { Link } from 'react-router-dom';

const BookSection = () => {
  return (
    <section className="relative bg-black text-white py-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 flex items-center justify-center opacity-100">
        <img
          src={require('../assets/images/ThreeBlackDamask.webp')}
          alt="Three Black Damask Background"
          className="w-full h-full object-cover"
        />
      </div>
      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
        {/* Book heading with overlaid EASTON • SINCE 2005 */}
        <div className="relative mb-8">
          {/* Script heading */}
          <h1
            className="text-[#4B3E29] mb-4"
            style={{ fontFamily: 'Quentin, cursive', fontSize: 'clamp(48px, 15vw, 160px)' }}
          >
            Book
          </h1>
          {/* EASTON • SINCE 2005 overlaid on Book */}
          <p className="uppercase tracking-[0.2em] text-xs sm:text-sm md:text-base text-gray-200 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            EASTON • SINCE 2005
          </p>
        </div>
        
        {/* Main heading */}
        <h2
          className="font-bold text-white mb-6 leading-tight"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 'clamp(20px, 6vw, 40px)',
            letterSpacing: '.04em'
          }}
        >
          YOU DESERVE THE VERY BEST
        </h2>
        {/* Description */}
        <p
          className="text-center mx-auto mb-8 leading-relaxed text-sm sm:text-base md:text-lg"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Are you <span className="font-semibold">OBSESSED</span> with your hair?<br/> If not.. We
          can change that! Come see us for a{' '}
          <span className="font-semibold">FREE CONSULTATION</span>.
        </p>
        {/* CTA */}
        <a
  href="tel:+16109233530"
  className="inline-block px-6 py-3 text-[#C7A064] font-bold tracking-widest uppercase underline hover:opacity-80 transition-opacity"
  style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '16px' }}
>
  CALL TO BOOK NOW
</a>

      </div>
    </section>
  );
};

export default BookSection;